module.exports = __webpack_public_path__ + "img/component_bg_m.9b813831.png";